import { render, staticRenderFns } from "./PlanMasterFile.vue?vue&type=template&id=138c3da0&scoped=true&"
import script from "./PlanMasterFile.vue?vue&type=script&lang=js&"
export * from "./PlanMasterFile.vue?vue&type=script&lang=js&"
import style0 from "./PlanMasterFile.vue?vue&type=style&index=0&id=138c3da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138c3da0",
  null
  
)

export default component.exports